function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { UserAchievementTier } from "../generated/users";
var ONE_DAY_MS = 24 * 60 * 60 * 1000;
export var getCurrentUserAccountAgeDays = function(currentUser) {
    var registerDate = currentUser.registerDate;
    if (registerDate == null) {
        return null;
    }
    var now = new Date();
    var diff = now.getTime() - registerDate.getTime();
    return Math.round(diff / ONE_DAY_MS);
};
export var getCurrentUserIsAnonymous = function(currentUser) {
    if (currentUser && currentUser.id != null && currentUser.id > 0) {
        return false;
    }
    return true;
};
export var defaultAnonymousUser = {
    statusId: 0,
    userLogins: [],
    groupIds: [],
    duplicateUsers: [],
    hasPhoneVerifications: false,
    failedNerdchas: 0,
    hasPendingNerdcha: false,
    deleteRequests: [],
    isAdmin: false,
    isKaggleBot: false,
    canAct: false,
    canBeSeen: false,
    isPhoneVerified: false,
    isNewUser: false,
    performanceTier: UserAchievementTier.NOVICE
};
export var mockAnonymousUser = _objectSpread({}, defaultAnonymousUser);
export var mockNormalUser = _objectSpreadProps(_objectSpread({}, defaultAnonymousUser), {
    id: 1,
    isAdmin: false,
    userName: "normal",
    displayName: "normal",
    email: "normal@normal.com",
    isPhoneVerified: true,
    profileUrl: "/normal",
    performanceTier: UserAchievementTier.NOVICE,
    thumbnailUrl: "/static/images/grey-thumbnail-small.png",
    registerDate: new Date(2000, 0, 1)
});
export var mockAdminUser = _objectSpreadProps(_objectSpread({}, defaultAnonymousUser), {
    id: 2,
    isAdmin: true,
    userName: "admin",
    displayName: "admin",
    email: "admin@admin.com",
    isPhoneVerified: true,
    profileUrl: "/admin",
    performanceTier: UserAchievementTier.STAFF,
    thumbnailUrl: "/static/images/grey-thumbnail-small.png",
    registerDate: new Date(2000, 0, 1)
});
export var mockFollower = {
    userId: 3,
    userName: "fol_follower",
    displayName: "Fol Follower",
    tier: UserAchievementTier.NOVICE,
    thumbnailUrl: "/static/images/grey-thumbnail-small.png"
};
export var userToUserAvatar = function(user) {
    var ref;
    return {
        id: (ref = user === null || user === void 0 ? void 0 : user.id) !== null && ref !== void 0 ? ref : 0,
        displayName: user.displayName,
        thumbnailUrl: user.thumbnailUrl,
        url: user.profileUrl,
        tier: user.performanceTier
    };
};
export var sessionClaimsToUserProto = function(claims) {
    if (claims.anon) {
        return defaultAnonymousUser;
    }
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    return _objectSpreadProps(_objectSpread({}, defaultAnonymousUser), {
        id: (ref = claims === null || claims === void 0 ? void 0 : claims.uid) !== null && ref !== void 0 ? ref : 0,
        profileUrl: (ref1 = claims === null || claims === void 0 ? void 0 : claims.profileUrl) !== null && ref1 !== void 0 ? ref1 : "",
        userName: (ref2 = claims === null || claims === void 0 ? void 0 : claims.sub) !== null && ref2 !== void 0 ? ref2 : "",
        displayName: (ref3 = claims === null || claims === void 0 ? void 0 : claims.displayName) !== null && ref3 !== void 0 ? ref3 : "",
        thumbnailUrl: (ref4 = claims === null || claims === void 0 ? void 0 : claims.thumbnailUrl) !== null && ref4 !== void 0 ? ref4 : "",
        email: (ref5 = claims === null || claims === void 0 ? void 0 : claims.email) !== null && ref5 !== void 0 ? ref5 : "",
        isPhoneVerified: (ref6 = claims === null || claims === void 0 ? void 0 : claims.verified) !== null && ref6 !== void 0 ? ref6 : false,
        performanceTier: (ref7 = claims === null || claims === void 0 ? void 0 : claims.tier) !== null && ref7 !== void 0 ? ref7 : UserAchievementTier.RECALC,
        isAdmin: (ref8 = claims === null || claims === void 0 ? void 0 : claims.admin) !== null && ref8 !== void 0 ? ref8 : false
    });
};
